export enum ActionButtonEnum {
    NotClicable = 0,
    ViewExposures = 1,
    CreateExposuresReport = 2,
    Edit = 3,
    Move = 4,
    Copy = 5,
    Delete = 6
}